// src/config/seo/seoConfig.js
// Configuração global de SEO - dados da empresa, contatos, URLs

const seoConfig = {
  // Site
  siteUrl: 'https://verdemusgonatural.com.br',
  siteName: 'Verde Musgo Natural',

  // Empresa
  company: {
    name: 'Verde Musgo Natural',
    fullDescription:
      'Fornecedor de hortaliças e folhosas sem agrotóxicos no atacado para restaurantes, lanchonetes, hortifrutis e estabelecimentos em Embu-Guaçu, Itapecerica da Serra, Taboão da Serra, São Lourenço da Serra, Juquitiba e região de São Paulo.',
    shortDescription: 'Fornecedor de hortaliças no atacado em Embu-Guaçu e região, com frescor, qualidade e entregas diretas.',

    // Localização
    address: 'Embu-Guaçu, SP',
    cities: ['Embu-Guaçu', 'Itapecerica da Serra', 'Taboão da Serra', 'São Lourenço da Serra', 'Juquitiba', 'Zona Sul de São Paulo', 'Zona Oeste de São Paulo'],

    // Contatos - ATUALIZAR COM DADOS REAIS
    whatsapp: '+55 (11) 920-929-438',
    email: 'verdemusgonatural@gmail.com',

    // Logo e imagens
    logo: '/logo.png',
    favicon: '/favicon.ico',

    // Redes sociais
    socialLinks: {
      instagram: 'https://instagram.com/verdemusgo.natural',
      youtube: 'https://youtube.com/...',
      facebook: 'https://facebook.com/...'
    }
  },

  // URLs externas
  externalLinks: {
    loja: 'https://loja.verdemusgonatural.com.br',
    tracking: 'https://track.verdemusgonatural.com.br',
    blog: 'https://blog.verdemusgonatural.com.br'
  },

  // SEO Global
  globalKeywords: ['agroecológico', 'orgânico', 'hortaliças', 'sustentável', 'São Paulo'],
  language: 'pt-BR',

  // Meta tags padrão
  defaultMeta: {
    charset: 'utf-8',
    viewport: 'width=device-width, initial-scale=1',
    colorScheme: 'light'
  }
};

export default seoConfig;
